import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  locationTimeslot: (state: State) => state.locationTimeslot,
  tenantLocationTimeslots: (state: State) => state.tenantLocationTimeslots,
  locationTimeslotCount: (state: State) => state.locationTimeslotCount,
  locationTimeslotInitData: (state: State) => state.locationTimeslotInitData
} as GetterTree<State, any>;
